/**
 * To create a toggle:
 *
 * Add the following data attributes to a checkbox input
 * data-toggle="toggle"
 * data-on="Text for switch on"
 * data-off="Text for switch off"
 * data-onstyle="class for switch on"
 * data-offstyle="class for switch off"
 * data-class="class for switch wrapper"
 **/

// This is here to ensure that jQuery is available outside of webpack.
if (typeof global.jQuery === "undefined") {
    global.$ = global.jQuery = jQuery;
}

import utils from "./plugin.utls.jquery";

// @TODO render the switch in its correct state to begin with; currently it renders in an on state, even if it should be off.
(function ($, window, document, undefined) {
    "use strict";

    const pluginName = "toggleSwitch";

    // Using a WeakMap here lets us keep track of Plugin instances without
    // worrying about leaking memory if/when the DOM elements go away.
    const instances = new WeakMap();

    /**
     * Plugin constructor.
     *
     * @param {*} element
     * @param {object} config
     *
     * @constructor
     */
    function Plugin(element, config) {
        this.element = element;

        this.config = {
            ...this._defaults,
            ...utils.getDataAttributes(element),
            ...typeof config === "object" && config ? config : {}
        };

        this.textWidth = function (text) {
            // Strip out HTML as it will affect the overall width
            do {
                text = (text ?? "").replace(new RegExp(/<([^\s]+)[^>]*>(?:(.*?)<\/\1>)?/, "g"), "$2");
            } while (text.match(/<[^>]+>/))

            if (text === undefined || text === null || text === '') {
                return 10;
            }

            const canvas = this.textWidth.canvas || (this.textWidth.canvas = document.createElement("canvas"));
            const context = canvas.getContext("2d");
            // TODO Look into using CSS inheritance to set the font size.
            context.font = "14px arial";
            return context.measureText(text).width;
        };

        return this.init();
    }

    Plugin.toggle = function (event, opts) {
        const input = $(this).parent().prev();
        const instance = instances.get(input.get(0));
        const options = $.extend({activateChange: true}, opts);

        if (instance.locked) {
            return this;
        }

        instance.lock();

        if ($(this).attr("aria-pressed") === "true") {
            input.trigger("off.start.toggle-switch");
            instance.off();
            input.trigger("off.end.toggle-switch");
        } else {
            input.trigger("on.start.toggle-switch");
            instance.on();
            input.trigger("on.end.toggle-switch");
        }

        // This does not appear to be triggered by the Chrome or Firefox.
        // TODO Check in Internet Explorer

        if (options.activateChange) {
            input.trigger("change");
        }

        instance.unlock();
        return this;
    };

    Plugin.prototype = {
        _defaults: {},

        /**
         * The jQuery toggle button.
         */
        button: undefined,

        /**
         * The DOM element.
         */
        element: undefined,
        locked: false,

        lock: function () {
            this.locked = true;
            return this;
        },

        unlock: function () {
            this.locked = false;
            return this;
        },

        on: function () {
            const button = this.button;
            const input = $(this.element);
            if (button === undefined) {
                return false;
            }

            $(".buttonTextLeft", button).html(this.config["on"] || "");
            button.addClass(this.config["onstyle"] || "btn-primary");
            button.removeClass(this.config["offstyle"] || "btn-default");
            button.animate({left: "-8px"}, 300, "swing", function () {
                $(".buttonTextRight", button).html("");
            });
            button.attr("aria-pressed", "true");
            input.prop("checked", true);

            return this;
        },

        off: function () {
            const button = this.button;
            const input = $(this.element);
            if (button === undefined) {
                return false;
            }

            const width = Math.ceil(button.parent().width());
            $(".buttonTextRight", button).html(this.config["off"] || "");
            button.addClass(this.config["offstyle"] || "btn-default");
            button.removeClass(this.config["onstyle"] || "btn-primary");
            button.animate({left: width * -1 + 4 + "px"}, 300, "swing", function () {
                $(".buttonTextLeft", button).html("");
            });
            button.attr("aria-pressed", "false");
            input.prop("checked", false);

            return this;
        },

        triggerToggle: function () {
            const self = this;
            $(this.element).each(function () {
                if ($(this).is(":checked")) {
                    self.on();
                }
                else {
                    self.off();
                }
            })
        },

        init: function () {
            const self = this;
            const config = this.config;

            $(this.element).each(function () {
                const input = $(this);
                const checked = input.is(":checked");

                let button;
                if (!input.hasClass("toggle-switched")) {
                    input.addClass("toggle-switched");

                    button = $("<button type=button data-toggle=toggle-switch></button>");
                    button.attr("aria-pressed", !checked);
                    button.prop("disabled", input.prop("disabled"));

                    if (button.prop("disabled")) {
                        button.addClass("disabled");
                    }

                    const minWidth = Math.ceil(Math.max(self.textWidth(config["on"]), self.textWidth(config["off"])) + 25);
                    const handle = "<span class=buttonTextLeft></span>" +
                        "<span class=buttonHandle>&nbsp;</span>" +
                        "<span class=buttonTextRight></span>";

                    input.after(button);
                    button.wrap(`<div class="toggleButtonWrapper ${config["class"] || ""}"></div>`);

                    button.parent().css("max-width", minWidth + "px");
                    button.parent().css("width", minWidth + "px");
                    button.addClass("btn btn-sm");
                    button.css("min-width", minWidth * 2 + "px").css("position", "relative");
                    button.html(handle);

                    $(".buttonTextLeft", button).css("width", minWidth - 15 + "px");
                    $(".buttonTextRight", button).css("width", minWidth - 15 + "px");

                    // Pass clicking the label for a checkbox through to the button.
                    if (input.attr("id")) {
                        const label = input.parent().find(`[for=${input.attr("id")}]`);
                        label.on("click.toggle-switch", () => button.trigger("click.toggle-switch"));
                    }
                }

                self.button = button;

                const init = () => checked ? self.on() : self.off();

                // If the input is a part of a form, listen for a form reset so
                // that we can reset the toggle visually back to its original
                // state.
                input.parents("form").on("reset.toggle-switch", (e) => !e.isDefaultPrevented() && init());
                init();
            });

            return this;
        },
    };

    $("body")
        .on({"click.toggle-switch": Plugin.toggle}, "[data-toggle=toggle-switch]");

    $.fn[pluginName] = function (config) {
        return this.each(function () {
            const _config = typeof config === "object" && config;

            if (!instances.has(this)) {
                instances.set(this, new Plugin(this, _config));
            }

            const instance = instances.get(this);
            if (typeof config === "string") {
                if (typeof instance[config] === "undefined") {
                    throw new TypeError(`No method named "${config}"`);
                }

                // Run the given command; e.g., $("#foo").toggleSwitch("click")
                instance[config]();
            }
        });
    };
})(jQuery, window, document);
